module.exports = __webpack_public_path__ + "static/media/logo_vert.fe895c70.png";